import React, { useMemo } from "react";
import { TransactionListItem } from "@common/schemas/transaction.schema";
import { formatBusinessDate, formatDateOnly } from "@helpers/date";
import styles from "./TransactionDateColumnContent.module.scss";

interface Props {
    transaction: TransactionListItem;
}

export const TransactionDateColumnContent: React.FC<Props> = ({
    transaction,
}) => {
    const formattedTransactionDate = useMemo(
        () =>
            transaction.dateOnly
                ? formatDateOnly(transaction.dateOnly)
                : formatBusinessDate(transaction.date),
        [transaction.date, transaction.dateOnly],
    );

    return (
        <span className={styles.value} data-testid="transaction-list-item-date">
            {formattedTransactionDate}
        </span>
    );
};
